import { axiosInstance } from "../axiosInstance";

export function sendOTP(phoneNumber) {
  return axiosInstance({
    method: "get",
    url: "customerOTPGeneration.php?number=" + phoneNumber,
  });
}

export function authenticateOTP(data) {
  return axiosInstance({
    method: "post",
    url: "customerOTPAuth.php",
    data: data,
  });
}

export function getCustomerInfo(phoneNumber) {
  return axiosInstance({
    method: "get",
    url: "customer_get_by_phone.php?phone=" + phoneNumber,
  });
}

export function createLeadOnLogin(customerDetails, type) {
  return axiosInstance({
    method: "post",
    url: "userlogin_estimate_create_service.php" ,
    data: { customerDetails: customerDetails ,  type: type},
  });
}

export function checkForDuplicateEmail(email) {
  return axiosInstance({
    method: "post",
    url: "customer_get_by_email.php",
    data: { email: email },
  });
}

export function registerCustomer(data) {
  return axiosInstance({
    method: "post",
    url: "customer_create_service.php",
    data: data,
  });
}